import { gql } from '@apollo/client';

import { Exercise } from 'modules/exercises/types';
import { exerciseFragment } from 'modules/exercises/graphql/fragments';

export interface GetAssignmentExercisesQueryVariables {
  courseId: string;
  assignmentId: string;
}

export interface GetAssignmentExercisesQueryResult {
  exercises: Exercise[];
}

export const getAssignmentExercisesQuery = gql`
  query GetAssignmentExercisesQuery($courseId: String!, $assignmentId: String!) {
    exercises(courseId: $courseId, assignmentId: $assignmentId)
      @rest(type: "Exercise", path: "courses/{args.courseId}/assignments/{args.assignmentId}/exercises") {
      ...Exercise
    }
  }
  ${exerciseFragment}
`;
